import Helpers from '@/helpers/index';
import {ResponseInnerMessage, ActionInnerMessage, ReplyMessageOptions } from '@/hosted_fields/common/types';
import Errors, { CbError } from '@/hosted_fields/common/errors';

export default class ReplyMessage {
  messageId: string;
  targetDomain: string;
  selfDestructor: number;
  messageListener: number;
  options: ReplyMessageOptions;
  
  resolver: (value?: ActionInnerMessage | ResponseInnerMessage) => void;
  rejector: (reason?: any) => void;
  
  constructor(targetDomain, options: ReplyMessageOptions={}) {
    this.messageId = Helpers.genUuid();
    this.targetDomain = targetDomain;
    this.options = options

    const selfDestructTimeout = options.timeout || 5000;
    this.selfDestructor = window.setTimeout(() => {
      // console.error(options.action, 'timed out')
      Helpers.sendKVL({
        action: 'message_action_timeout',
        message_action: options.action,
      })
      this.rejector(new CbError(Errors.replyTimeout));
    }, selfDestructTimeout);
  }

  markAsRecieved() {
    window.clearTimeout(this.selfDestructor);
  }
}